// Copyright (c) 2016 Deere & Company

import actions from '../action-list';

export const updateIsEditable = isEditable => ({
    isEditable,
    type: actions.UPDATE_CLAIM_JDP_IS_EDITABLE
});



// WEBPACK FOOTER //
// ./src/claim/marketing/jdp/action-creators/is-editable.js